import { useMemo } from 'react';
import { Store } from '../codegen/graphql';
import { getEligibleAdvertisingZoneStores } from '../helpers/storeSelectionHelper';

export function useEligibleStoresCount(advertisingZoneStores: Store[]): number {
    return useMemo(() => {
        return getEligibleAdvertisingZoneStores(advertisingZoneStores).length;
    }, [advertisingZoneStores]);
}
